import { Contracts, ContractNames } from "@airdao/bond-periphery/core";
import { BigNumberish } from "ethers";
import { TimeFrameOracle } from "@airdao/bond-periphery/core/contracts/types";

type TimeFrame = {
  startTime: BigNumberish;
  endTime: BigNumberish;
};

export async function GetFrame(contracts: Contracts, contractName: ContractNames = ContractNames.TimeFrameOracle): Promise<TimeFrame> {
  const oracle = contracts.getContractByName(contractName) as unknown as TimeFrameOracle;
  const rawFrame = await oracle.getTimeFrame();
  return {
    startTime: rawFrame.startTime,
    endTime: rawFrame.endTime,
  } as TimeFrame;
}

export async function GetStart(contracts: Contracts, contractName: ContractNames = ContractNames.TimeFrameOracle): Promise<bigint> {
  const oracle = contracts.getContractByName(contractName) as unknown as TimeFrameOracle;
  return await oracle.getStart();
}

export async function GetEnd(contracts: Contracts, contractName: ContractNames = ContractNames.TimeFrameOracle): Promise<bigint> {
  const oracle = contracts.getContractByName(contractName) as unknown as TimeFrameOracle;
  return await oracle.getEnd();
}

export const GetterMethods = {
  GetFrame,
  GetStart,
  GetEnd,
};

export default GetterMethods;